$('.product-picture').slick({
  slidesToShow: 1,
  slidesToScroll: 1,
  arrows: false,
  fade: true,
  asNavFor: '.product-pictures-list',
});

$('.product-pictures-list').slick({
  slidesToShow: 5,
  asNavFor: '.product-picture',
  dots: false,
  arrows: false,
  infinite: false,
  focusOnSelect: true,
  rows: 1,
});